// Format a price stored in cents for display.
//   null  → null (caller decides whether to render anything)
//   0     → "Free"
//   1500  → "$15"
//   1550  → "$15.50"
export function formatPrice(cents: number | null | undefined): string | null {
  if (cents == null) return null;
  if (cents === 0) return "Free";
  const dollars = cents / 100;
  return dollars % 1 === 0 ? `$${dollars}` : `$${dollars.toFixed(2)}`;
}
